<template>
  <!-- {{ summaryDetail }} -->
  <main class="evalFigma w-full summaryDetailPg">
    <EvalShell title="Review & Submit" subTitle="Here are the details for the services you have selected" :step="5"
      :show-details="false" :show-unit="false" :job-id="$route.params.id" :unit-id="$route.query.unit_id">

      <!-- Figma E6 (Submission Failed) -->
      <div class="mt-[10px]">
        <div v-if="submitFailed"
          class="flex flex-wrap items-center gap-[12px] mb-[20px] px-[18px] py-[12px] largeDesktop:py-[16px] rounded-[10px] border-1 border-[#F5C2C2] bg-[#FDECEC] font-roboto">
          <img src="../../assets/images/warning-icon.png" alt=""
                  class="w-[20px] h-[20px] object-contain">
          <div class="flex-1 min-w-0">
            <p class="m-0 text-[14px] largeDesktop:text-[16px] leading-[20px] font-medium text-[#C43333]">Couldn't
              submit the evaluation</p>
            <p class="mb-0 !mt-[5px] text-[12px] largeDesktop:text-[14px] leading-[17px] text-[#A85252]">The quote wasn't saved.
              Your work is kept as a draft — try again.</p>
          </div>
          <button type="button"
            class="h-[32px] largeDesktop:h-[42px] px-[16px] largeDesktop:px-[24px] rounded-[8px] border-0 bg-[#E23D3D] text-[13px] largeDesktop:text-[14px] font-medium text-white"
            @click="retrySubmit()">
            RETRY
          </button>
        </div>

        <div class="summaryDetailSec">
          <summary_detail_card :details="summaryDetail" editable />
          <div
            class="flex items-center justify-between gap-[16px] mt-[14px] px-[20px] py-[14px] largeDesktop:py-[18px] rounded-[10px] bg-[#F3F4F7] font-roboto">
            <span class="text-[17px] largeDesktop:text-[18px] leading-[25px] font-semibold text-[#2E3138]">Total Amount</span>
            <span class="text-[20px] largeDesktop:text-[22px] leading-[30px] font-bold text-[#0E2F7E]">{{ summaryDetail.total_text }}</span>
          </div>
        </div>
      </div>

      <!-- in the card on laptop; below laptop under the card (Figma mobile E3) -->
      <template #actions>
        <div class="absolute -bottom-[30px] left-0 right-0 laptop:relative laptop:bottom-0  flex flex-wrap justify-center items-center gap-[20px] mt-[30px] mobile:mb-[10px] laptop:mb-0">
          <EvalButton variant="back" @click="backButtonClicked()" />
          <EvalButton variant="submit" v-if="!is_update" @click="nextButtonClicked()">
            Submit Evaluation
          </EvalButton>
          <EvalButton v-else @click="updateButtonClicked()">
            Update Evaluation
          </EvalButton>
        </div>
      </template>
    </EvalShell>

    <!-- Figma E4 (Modal): shown while the evaluation is being submitted -->
    <div v-if="submitting" class="fixed inset-0 z-[2000] flex items-center justify-center bg-[#000]/20 font-roboto">
      <div
        class="w-[360px] largeDesktop:w-[460px] max-w-[90vw] px-[40px] py-[35px] rounded-[18px] bg-white shadow-[0px_0px_20px_0px_#00000026] text-center">
        <span
          class="inline-block w-[48px] h-[48px] largeDesktop:w-[64px] largeDesktop:h-[64px] rounded-full border-[5px] border-[#6C79E0] border-t-transparent animate-spin" />
        <p class="my-[14px] text-[16px] largeDesktop:text-[19px] font-semibold text-[#2E3138]">{{ is_update ? 'Updating evaluation…' :
          'Submitting evaluation…' }}</p>
        <p class="m-0 mt-[6px] text-[13px] largeDesktop:text-[14px] leading-[18px] text-[#5B616B]">Generating the quote and notifying the
          consumer. This usually takes a few seconds.</p>
        <div class="mt-[20px] h-[7px] rounded-full bg-[#EAECF1] overflow-hidden w-[80%] mx-auto">
          <div class="h-full w-2/3 rounded-full bg-[#6C79E0] animate-pulse" />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import EvalShell from "@/components/nest_components/EvalShell.vue";
import EvalButton from "@/components/nest_components/EvalButton.vue";
import summary_detail_card from "../../components/nest_components/summary_detail_card.vue";
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  components: {
    EvalShell,
    EvalButton,
    summary_detail_card,
  },

  data() {
    return {
      jobId: this.$route.params.id,
      unit_id: this.$route.query.unit_id,
      is_update: (this.$route.query.is_update) ?? 0,
      // Figma E4 overlay / E6 banner
      submitting: false,
      submitFailed: false,
      submitDone: false,
    };
  },

  computed: {
    ...mapGetters(["summaryDetail", "diagnosisSubmitResponse", "diagnosisUpdateResponse"]),
  },

  watch: {
    summaryDetail: function () { },

    diagnosisUpdateResponse: function () {
      this.submitDone = true;
      if (this.$route.query.is_from_mobile == 1) {
        let query = {
          is_from_mobile: this.$route.query.is_from_mobile,
          redirect_to: 'diagnosis_submitted',
        }
        if (this.diagnosisUpdateResponse?.child_booking_id) {
          query["child_id"] = this.diagnosisUpdateResponse?.child_booking_id
        }
        this.$router.push({
          path: `/success`,
          query: query,
        });
      } else {
        // Figma F1: success modal, "Job Details" goes where the old toast + redirect went
        this.showOnJobDetails("Evaluation Updated");
      }

    },

    diagnosisSubmitResponse: function () {
      this.submitDone = true;
      if (this.$route.query.is_from_mobile == 1) {
        let query = {
          is_from_mobile: this.$route.query.is_from_mobile,
          redirect_to: 'diagnosis_submitted',
        }
        if (this.diagnosisSubmitResponse?.child_booking_id) {
          query["child_id"] = this.diagnosisSubmitResponse?.child_booking_id
        }
        this.$router.push({
          path: `/success`,
          query: query,
        });
      } else {
        // Figma F1: success modal, "Job Details" goes where the old toast + redirect went
        this.showOnJobDetails("Evaluation Submitted");
      }
    },
  },

  mounted() {
    this.getSummaryDetail({
      booking_id: this.jobId,
    });
  },

  methods: {
    ...mapActions(["getSummaryDetail", "diagnosisSubmit", "diagnosisUpdate"]),

    // same submit / update calls as before, wrapped for the E4 overlay and E6 banner
    async runSubmit(action) {
      // a second diagnosis/submit closes the job at $0 (QA D-32 / G-55)
      if (this.submitting || this.submitDone) return;
      this.submitFailed = false;
      this.submitDone = false;
      this.submitting = true;
      await action({ booking_id: this.jobId });
      // response watchers run on the next tick
      await this.$nextTick();
      this.submitting = false;
      if (!this.submitDone) this.submitFailed = true;
    },

    // replace, so Back from the job does not reopen this page; the job shows the Figma F1 popup once (history state)
    showOnJobDetails(title) {
      this.$router.replace({
        path: `/job/detail/${this.$route.params.id}`,
        state: { evalSubmitted: { title, total: this.summaryDetail.total_text || "" } },
      });
    },

    retrySubmit() {
      this.runSubmit(this.is_update ? this.diagnosisUpdate : this.diagnosisSubmit);
    },

    backButtonClicked() {
      this.$router.go(-1);
    },

    nextButtonClicked() {
      this.$dialog.show({
        title: "Submit Evaluation",
        text: "Are you sure you want to submit this evaluation?",
        onConfirm: () => {
          this.runSubmit(this.diagnosisSubmit);
        },
      });
    },

    updateButtonClicked() {
      this.$dialog.show({
        title: "Update Evaluation",
        text: "Are you sure you want to update this evaluation?",
        onConfirm: () => {
          this.runSubmit(this.diagnosisUpdate);
        },
      });
    },
  },
};
</script>

// getSummaryDetail
